import {AxiosError} from 'axios';
import {useQuery, UseQueryOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

import type {Member} from '../types';

type QueryParams = {
  groupId: string;
};

type Response = {
  data: Member[];
};

const queryKey = (groupId: string) => ['managers', groupId];
const queryFn = (groupId: string) => () =>
  api
    .get<Response>(`v2/groups/${groupId}/members`, {
      params: {
        per_page: 10,
        page: 1,
        managers: 1,
      },
    })
    .then((res) => res.data.data);

export function useManagersQuery({groupId}: QueryParams, options?: UseQueryOptions<Response['data'], AxiosError>) {
  return useQuery<Response['data'], AxiosError>(queryKey(groupId), queryFn(groupId), {enabled: !!groupId, ...options});
}

useManagersQuery.queryKey = queryKey;
useManagersQuery.queryFn = queryFn;
